class ArchivesTabs {
    constructor(className) {
        this.tabsRow = document.querySelectorAll("." + className);
        this.events();
    }
    events() {
        this.tabsRow.forEach((element, number) => {
            element.addEventListener("click", (e) => {
                this.toggleSelected(e);
            })
        });
    }
    toggleSelected(e) {
        this.tabsRow.forEach(e => e.classList.remove('archives-tabs__item--selected'))
        e.target.classList.add('archives-tabs__item--selected')
    }
}
export default ArchivesTabs;
